<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { useAccountStore } from '@/store/account'
import LogoIconGray from '@/components/Logo/LogoIconGray.vue'
import LogoIconDark from '@/components/Logo/LogoIconDark.vue'
import LogoIconLight from '@/components/Logo/LogoIconLight.vue'
import {isActiveTrialPeriod} from '@/utils/date'


withDefaults(
  defineProps<{
    logoColor?: 'green' | 'gray' | 'pale'
  }>(),
  {
    logoColor: 'gray'
  }
)

const { t } = useI18n({ useScope: 'global' })

const { hasRole, isTrustedTrucker } = useAccountStore()


</script>

<template>
  <div>
    <slot
      v-if="
        isTrustedTrucker ||
        hasRole('siteowner') ||
        isActiveTrialPeriod('yearEnd2025')
      "
    ></slot>
    <div v-else class="relative py-4">
      <div
        class="absolute inset-0 z-20 flex h-full w-full flex-col items-center justify-center gap-2 backdrop-blur-sm"
      >
        <LogoIconGray v-if="logoColor === 'gray'" class="h-10 w-10" />
        <LogoIconDark v-if="logoColor === 'green'" class="h-10 w-10" />
        <LogoIconLight v-if="logoColor === 'pale'" class="h-10 w-10" />
        <p class="text-base font-semibold">
          {{ t('locked.onlyForTrustedTruckers') }}
        </p>
      </div>
      <slot name="locked-content">
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Soluta
        voluptatem tempora obcaecati consectetur sint ipsa enim vel neque
        dolorem facilis quos illum, fugit numquam modi! Unde perferendis quasi
        delectus labore.
      </slot>
    </div>
  </div>
</template>
